import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import lodashFind from 'lodash/find';

import constants from '../../../Config/constants';
import DateHelper from '../../../Helper/Date';
import { selectReservationFilter } from '../../../RTK/filter/selectors';

dayjs.extend(customParseFormat);

const useListingHandler = () => {
  const listingFilter = useSelector(selectReservationFilter);

  const isEvent =
    listingFilter.reservationType?.value === constants.RESERVATION_TYPE.EVENT;
  const selectedDate = listingFilter.date
    ? dayjs(listingFilter.date).format(constants.DBDATE_FORMAT)
    : undefined;

  const dateFilter = DateHelper.getDateFilter(
    listingFilter.reservationType?.value,
    selectedDate,
  );

  const selectedEventFilterData = lodashFind(constants.eventFilterData, {
    label: listingFilter.dateText || constants.eventFilterData[1].label,
  });

  const selectedFilter = useMemo(
    () => ({
      event_date_range: selectedEventFilterData?.value,
      date: isEvent ? undefined : dateFilter,
      party_size: listingFilter.party_size,
      time: isEvent ? undefined : listingFilter.time,
      is_event: isEvent,
    }),
    [
      dateFilter,
      isEvent,
      listingFilter.party_size,
      listingFilter.time,
      selectedEventFilterData?.value,
    ],
  );

  const payload = useMemo(
    () => ({
      date: dateFilter,
      location: `${listingFilter.location?.latitude},${listingFilter.location?.longitude}`,
      party_size: listingFilter.party_size,
      time: selectedFilter.time,
      type: listingFilter.reservationType?.value,
      sort: ['price,asc'],
    }),
    [dateFilter, selectedFilter.time, listingFilter],
  );

  const skip = useMemo(
    () => (isEvent ? false : !payload.time),
    [isEvent, payload.time],
  );

  return {
    isEvent,
    selectedFilter,
    requestPayload: payload,
    requestSkip: skip,
  };
};

export default useListingHandler;
